import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { updateApplicantId } from '../../../_redux/SeletedapplicantIdsSlice';
import { filterClientsAsync } from '../../../_redux/_services/ClientsSlice';
import { updateSnackbar } from '../../../_redux/SnackbarSlice';
import * as _ser from '../../../_redux/_services/JobPostingSlice';
import { Encrypt } from '../../../_utilities/_encryptDecryptHelper';
import { setBreadCrumb } from '../../../_utilities/breadCrumb';
import { getUserDetails, GetUserInfo } from '../../../_utilities/getUserInfo';
import MessageBar from '../../../components/SnackBar/MessageBar';
import CreateDocuments from '../PostingsDocuments/CreateDocuments';
import JobPortal from '../PostingsJobPortal/JobPortal';
import PostingsPortals from '../PostingsPortals/PostingsPortals';
import './PostingCreateTabs.css';
import PostingsCreate from './PostingsCreate';
import RecommendedTalent from './RecommendedTalent';
import Cookies from "js-cookie";
import { resetSelectedJobPosting } from '../../../_redux/SelectedJobPostingSlice';

const initalState = { data: null, message: '', isloader: true };

const getJobPostingPath = () => {
  return (
    Cookies.get("jobPostingViewPreference") || "/ats/layout/jobpostings/landing"
  );
};

const PostingsCreateTabs = () => {
  const [isJobDetails, setIsJobDetails] = useState(false);
  const [isDocData, setIsDocData] = useState(false);
  const [isQuestionData, setIsQuestionData] = useState(false);
  const [isPortalData, setIsPortalData] = useState(false);

  const [getCreatedJob, setGetCreatedJob] = useState(null);
  const [activeComponent, setActiveComponent] = useState('');
  const [activeStep, setActiveStep] = useState(['']);
  const [jobDetailsID, setJobDetailsID] = useState(null);
  const [clientList, setClientList] = useState([]);
  const [open, setOpen] = useState();

  const [listOfPF, setListOfPF] = useState(
    JSON.parse(JSON.stringify(listOfPlatform))
  );
  const [flatFee, setFlatFee] = useState('0');
  const [flatFeeCountryId, setFlatFeeCountryId] = useState('0');
  const [selectedVendors, setselectedVendors] = useState([]);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [hasUnsavedQuestions, setHasUnsavedQuestions] = useState(false);
  const [hasCloneQuestions, setHasCloneQuestions] = useState(false);

  // Continue button visible only when no clone questions pending AND no unsaved edits
  useEffect(() => {
    setIsButtonVisible(!hasCloneQuestions && !hasUnsavedQuestions);
  }, [hasCloneQuestions, hasUnsavedQuestions]);

  const label = { inputProps: { 'aria-label': 'Switch demo' } };
  const Addjobpostingscode = useSelector((state) => state.Addjobpostings.data);
  const insertId = useSelector((state) => state.Addjobpostings.insertId);
  const showMessage = useSelector((state) => state.Snackbar.message);
  const showMsgType = useSelector((state) => state.Snackbar.type);
  const getDetails = useSelector((state) => state.Jobpostingsbyid.data);
  const updateCode = useSelector((state) => state.Editjobpostings.data);
  const vendorsRes = useSelector((state) => state.GetListVendors.data);
  const clientVal = useSelector((state) => state.FilterClients.data);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    async function init() {
      let userDetails = await GetUserInfo();
      let val =
        userDetails[0].flatFee !== null && userDetails[0].flatFee !== 0
          ? userDetails[0].flatFee
          : '';
      let CountryIdval =
        userDetails[0].flatFeeCountryId !== null &&
          userDetails[0].flatFeeCountryId !== 0
          ? userDetails[0].flatFeeCountryId
          : '';
      setFlatFee(val);
      setFlatFeeCountryId(CountryIdval);
    }

    init();
  }, []);

  const updateHandler = (val, type) => {
    if (type === 'flatFee') {
      setFlatFee(val);
    } else if (type === 'vendor') {
      setselectedVendors(val.map((x) => x.id));
    }
  };

  const updateCountryHandler = (val) => {
    setFlatFeeCountryId(val);
  };

  useEffect(() => {
    setIsJobDetails(false);
    setIsDocData(false);
    setIsQuestionData(false);
    setIsPortalData(false);
    const { pathname } = window.location;
    const jobId = pathname.split("/").pop();
    setActiveComponent(jobId);
    let Index = postingTabs.findIndex((x) => x.name === jobId);
    let array = [];
    for (var i = Index; i >= 0; i--) {
      array.push(postingTabs[i].name);
    }
    setActiveStep(array);
    if (location.state?.jobId) {
      sessionStorage.setItem('jobDetailsID', location.state.jobId);
      setJobDetailsID(location.state.jobId);
      if (jobId === 'portals') {
        dispatch(_ser.jobpostingsbyidAsync(location.state.jobId));
      }
    } else {
      let ID = sessionStorage.getItem('jobDetailsID');
      setJobDetailsID(ID);
      if (
        jobId === 'portals' ||
        jobId === 'questions' ||
        jobId === 'recommendedTalent'
      ) {
        dispatch(_ser.jobpostingsbyidAsync(ID));
      }
    }
  }, [location]);

  useEffect(() => {
    console.log('jobDetailsID', jobDetailsID);
  }, [jobDetailsID]);

  useEffect(() => {
    console.log(
      'isJobDetails, isDocData, isQuestionData, isPortalData',
      isJobDetails,
      isDocData,
      isQuestionData,
      isPortalData
    );
  }, [isJobDetails, isDocData, isQuestionData, isPortalData]);

  const onChangeHandler = (e, type) => {
    if (type === 'jobdetails') {
      setIsJobDetails(true);
    } else if (type === 'document') {
      setIsDocData(true);
    } else if (type === 'questions') {
      setIsQuestionData(true);
    } else if (type === 'portals') {
      setIsPortalData(true);
    }
  };

  useEffect(() => {
    const init = async () => {
      if (clientVal && clientVal.length > 0) {
        let clientValue = JSON.parse(JSON.stringify(clientVal));
        let ClientData = [];
        clientValue.forEach((e) => {
          if (e.status === 'Active') {
            e.clientName = e.clientName;
            ClientData.push(e);
          }
        });
        setClientList(ClientData);
      } else {
        const userInfo = await getUserDetails();
        if (userInfo) {
          dispatch(filterClientsAsync(''));
        }
      }
    };
    init();
  }, [clientVal]);

  const onReceiveDataHandler = (data, isData, type) => {
    if (type === 'jobdetails') {
      saveJobDetails(data);
    } else if (type === 'document') {
      if (data.length > 0) {
        saveJobDocument(data);
      } else {
        navigate('/ats/layout/jobpostings/create/questions');
      }
      setIsDocData(false);
    } else if (type === 'questions') {
      if (isData === false) {
        navigate('/ats/layout/jobpostings/create/portals');
        dispatch(_ser.getListofQuestionsStartReducer(initalState));
      } else {
        setOpen(true);
        setIsQuestionData(false);
      }
    } else if (type === 'CloneQuestions') {
      setHasCloneQuestions(data.length > 0);
    } else if (type === 'questionEditState') {
      setHasUnsavedQuestions(data);
    } else if (type === 'portals') {
      onSavePortalHandler();
      setIsPortalData(false);
    }
  };

  const saveJobDetails = async (formData) => {
    dispatch(_ser.addjobpostingsAsync(formData, true));
  };

  useEffect(() => {
    if (
      Addjobpostingscode === 200 &&
      (isJobDetails === true || isJobDetails === null)
    ) {
      dispatch(_ser.addjobpostingsStartReducer(initalState));
      navigate('/ats/layout/jobpostings/create/document', {
        state: { jobId: insertId },
      });
      dispatch(_ser.jobpostingsbyidAsync(insertId));
    }
    console.log('Addjobpostingscode', Addjobpostingscode);
    console.log('isJobDetails', isJobDetails);
  }, [Addjobpostingscode]);

  useEffect(() => {
    if (getDetails !== null && getDetails !== undefined) {
      let postingData = JSON.parse(JSON.stringify(getDetails));
      postingData.jobType = postingData.jobType.split(',');
      postingData.recruiters = postingData?.recruiters
        ? JSON.parse(postingData.recruiters)
        : [];
      postingData.clientName = {
        id: postingData?.clientId,
        clientName: postingData?.clientName,
      };
      setGetCreatedJob(postingData);
      let updateSkills = postingData?.primarySkills.replace(/\n/g, ',');
      Encrypt(updateSkills, 'getSkills');
      localStorage.setItem('JobIdentifier', postingData.affindaIdentifier);
      let name = `${postingData?.jobTitle} (${postingData?.jobCode})`;
      setBreadCrumb(postingData?.id, name, 'Job Code');
      dispatch(_ser.jobpostingsbyidStartReducer(initalState));
    }
  }, [getDetails]);

  const saveJobDocument = async (data) => {
    const userInfo = await getUserDetails();
    let formData = new FormData();
    let checkFileType = data.filter(
      (elem) =>
        elem.name.match(/jpg/) ||
        elem.name.match(/png/) ||
        elem.name.match(/jpeg/) ||
        elem.name.match(/JPEG/) ||
        elem.name.match(/SVG/) ||
        elem.name.match(/gif/)
    );
    if (checkFileType.length > 0) {
      console.log('jpg existssss');
      alert('file does not support');
    } else {
      for (let i = 0; i < data.length; i++) {
        // formData.append(`jobFiles[]`, data[i]);
      }
      formData.append(`jobFiles`, data[0]);
      formData.append('id', jobDetailsID);
      formData.append('userId', userInfo.userId);
      dispatch(_ser.uploadDocumentsAsync(jobDetailsID, formData, true))
        .then(() => {
          dispatch(_ser.uploadDocumentsStartReducer(initalState));
          navigate('/ats/layout/jobpostings/create/questions');
        })
        .catch(() => {
          // dispatch(updateSnackbar({ type: 'error', message: "Documents not saved!!!" }));
        });
    }
  };

  const onChangePlatformHandler = (e, item) => {
    let data = JSON.parse(JSON.stringify(listOfPF));
    let Index = data.findIndex((x) => x.id === item.id);
    if (Index !== -1) {
      data[Index].checked = e.target.checked;
      data[Index].value = e.target.checked ? 1 : 0;
      setListOfPF(data);
    }
  };

  const onSavePortalHandler = async () => {
    if (getCreatedJob !== null) {
      let newObj = JSON.parse(JSON.stringify(getCreatedJob));
      newObj.CSPortal = listOfPF[0].value;
      newObj.VSPortal = listOfPF[1].value;
      newObj.EPortal = listOfPF[2].value;
      newObj.JBPortal = listOfPF[3].value;
      newObj.flatFeeCountryId = flatFeeCountryId;
      setGetCreatedJob(newObj);

      const activeVendorsCount = vendorsRes ? vendorsRes.filter((x) => x?.vendorStatus === 1).length : 0;

      if (newObj.VSPortal === 1 && activeVendorsCount >= 1 && selectedVendors.length === 0) {
        dispatch(
          updateSnackbar({
            type: 'error',
            message: 'Please select the vendors',
          })
        );
        return;
      }

      newObj.recruiters = JSON.stringify(newObj.recruiters);
      newObj.jobType = newObj.jobType.toString();
      newObj.vendorIds = selectedVendors.length === 0 ? "[]" : selectedVendors.includes(0) ? '[0]' : JSON.stringify(selectedVendors);
      dispatch(_ser.editjobpostingsAsync(newObj.id, newObj));
    }
  };

  const onSaveAssociatedApplicantsHandler = async () => {
    navigate(getJobPostingPath());
    sessionStorage.removeItem('jobDetailsID');
    localStorage.removeItem('JobIdentifier');
    dispatch(resetSelectedJobPosting());
    dispatch(updateApplicantId([]));
  };

  useEffect(() => {
    if (updateCode === 200) {
      dispatch(_ser.editjobpostingsStartReducer(initalState));
      navigate('/ats/layout/jobpostings/create/recommendedTalent');
    }
  }, [updateCode, dispatch]);

  const currentStepIndex = postingTabs.findIndex((x) => x.name === activeComponent);
  const currentStep = currentStepIndex >= 0 ? currentStepIndex + 1 : 1;
  const currentTabTitle = currentStepIndex >= 0 ? postingTabs[currentStepIndex].title : '';
  const progressValue = (currentStep / postingTabs.length) * 100;

  const footerButtonConfig = (() => {
    switch (activeComponent) {
      case 'jobdetails':
        return {
          label: getCreatedJob === null ? 'Upload Details' : 'Save and Continue',
          onClick: (e) => onChangeHandler(e, 'jobdetails'),
          visible: true,
        };
      case 'document':
        return {
          label: getCreatedJob === null ? 'Upload Documents' : 'Continue',
          onClick: (e) => onChangeHandler(e, 'document'),
          visible: true,
        };
      case 'questions':
        return {
          label: getCreatedJob === null ? 'Add Questions' : 'Continue',
          onClick: (e) => onChangeHandler(e, 'questions'),
          visible: isButtonVisible,
        };
      case 'portals':
        return {
          label: getCreatedJob === null ? 'Add Portal' : 'Continue',
          onClick: (e) => onChangeHandler(e, 'portals'),
          visible: true,
        };
      case 'recommendedTalent':
        return {
          label: getCreatedJob === null ? 'Create Job' : 'Finish',
          onClick: onSaveAssociatedApplicantsHandler,
          visible: true,
        };
      default:
        return { label: 'Continue', onClick: () => { }, visible: false };
    }
  })();

  return (
    <>
      {showMessage !== '' ? (
        <MessageBar message={showMessage} type={showMsgType} />
      ) : (
        ''
      )}
      <div className="customSteps">
        <ul>
          {postingTabs.map((items, i) => {
            return (
              <li
                className={activeStep.includes(items.name) ? 'active' : ''}
                id={activeComponent === items.name ? 'active1' : ''}
              >
                <span>{items.id}</span>
                <span>{items.title}</span>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="stepsSection" id="stepsContent">
        {activeComponent === 'jobdetails' && (
          <div className="stepsInnerArea">
            <PostingsCreate
              isJobDetails={isJobDetails === true ? isJobDetails : isJobDetails}
              cloneJob={getCreatedJob}
              onResetValue={() => {
                setIsJobDetails(null);
              }}
              onReceiveData={onReceiveDataHandler}
            />
          </div>
        )}
        {activeComponent === 'document' && (
          <div className="stepsInnerArea">
            <CreateDocuments
              isDocData={isDocData ? isDocData : isDocData}
              onReceiveData={onReceiveDataHandler}
            />
          </div>
        )}
        {activeComponent === 'questions' && (
          <div className="stepsInnerArea">
            <h4 className="subHeading" style={{ paddingLeft: '35px' }}>
              {isButtonVisible
                ? 'Please add all the screening questions relevant to the Job Posting'
                : 'Select & Save Screening Questions'}
            </h4>
            <JobPortal
              isQuestionData={isQuestionData ? isQuestionData : isQuestionData}
              jobDetailsID={jobDetailsID}
              onReceiveData={onReceiveDataHandler}
              getCreatedJob={getCreatedJob}
            />
          </div>
        )}
        {activeComponent === 'portals' && (
          <div className="stepsInnerArea">
            <PostingsPortals
              componentType="Create"
              isPortalData={isPortalData ? isPortalData : isPortalData}
              onReceiveHandler={onChangePlatformHandler}
              data={listOfPF}
              flatFee={flatFee}
              flatFeeCountryId={flatFeeCountryId}
              vendors={selectedVendors}
              updateHandler={updateHandler}
              updateCountryHandler={updateCountryHandler}
              onReceiveData={onReceiveDataHandler}
            />
          </div>
        )}
        {activeComponent === 'recommendedTalent' && (
          <div className="stepsInnerArea" style={{ padding: '0 40px' }}>
            <RecommendedTalent
              getjobDetails={getCreatedJob}
              onReceiveData={onReceiveDataHandler}
            />
          </div>
        )}
      </div>

      {/* Sticky Footer */}
      <Box className="postings-sticky-footer">
        <Box className="footer-step-indicator">
          <Box className="footer-step-circle">{currentStep}</Box>
          <Typography className="footer-step-label">
            Step {currentStep} of {postingTabs.length} — {currentTabTitle}
          </Typography>
          <Box className="footer-progress-wrapper">
            <LinearProgress
              variant="determinate"
              value={progressValue}
              sx={{
                height: 5,
                borderRadius: 3,
                backgroundColor: '#555',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: 'var(--primary-bg-color)',
                  borderRadius: 3,
                },
              }}
            />
          </Box>
        </Box>

        <Box sx={{ flex: 1 }} />

        {footerButtonConfig.visible && (
          <Button
            variant="contained"
            size="medium"
            onClick={footerButtonConfig.onClick}
            style={{
              backgroundColor: 'var(--primary-bg-color)',
              color: 'var(--primary-background-text-color)',
              borderRadius: '10px',
              textTransform: 'capitalize',
              fontSize: '16px',
            }}
          >
            {footerButtonConfig.label}
          </Button>
        )}
      </Box>

      <Dialog
        open={open}
        keepMounted
        onClose={() => {
          setOpen(false);
        }}
        aria-describedby="alert-dialog"
        style={{ marginTop: '-21%' }}
      >
        <Box sx={{ width: '395px' }}>
          <DialogTitle className="diabtn">Confirm</DialogTitle>
          <DialogContent>
            <DialogContentText className="diabtnjob" id="alert-dialog">
              <p
                className="btntext"
                style={{ lineHeight: '1.6', padding: '0 31px' }}
              >
                Cloned screening questions have not been saved. Continuing will
                result in loss of data. Do you wish to proceed?
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="warning-actionbtns">
            <Button
              onClick={() => {
                setOpen(false);
              }}
            >
              <Link href="#" color="#131313ff">
                Cancel
              </Link>
            </Button>
            <Button
              onClick={() => {
                setOpen(false);
                navigate('/ats/layout/jobpostings/create/portals');
              }}
            >
              Continue
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default PostingsCreateTabs;

const postingTabs = [
  { id: 1, name: 'jobdetails', title: 'Job Details' },
  { id: 2, name: 'document', title: 'Documents' },
  { id: 3, name: 'questions', title: 'Questions' },
  { id: 4, name: 'portals', title: 'Portals' },
  { id: 5, name: 'recommendedTalent', title: 'Recommended Talent' },
];

const listOfPlatform = [
  {
    id: 3,
    name: 'CSPortal',
    title: 'Cloud Sourcing Platform',
    checked: false,
    value: 0,
  },
  {
    id: 2,
    name: 'VSPortal',
    title: 'Vendor Sourcing Platform',
    checked: false,
    value: 0,
  },
  {
    id: 4,
    name: 'EPortal',
    title: 'Employee Platform',
    checked: false,
    value: 0,
  },
  {
    id: 5,
    name: 'JBPortal',
    title: 'Job Board Platform',
    checked: false,
    value: 0,
  },
];
